<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form" label-width="100px" style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label-width prop="create_time" label="日期">
              <el-date-picker
                v-model="form.create_time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width prop="plan_name" label="所属计划">
              <el-input v-model="form.plan_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width prop="element_from" label="所属单元">
              <el-input v-model="form.element_from"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width prop="element_name" label="元素名称">
              <el-input v-model="form.element_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode" label="行业">
              <el-select clearable v-model="form.profession" placeholder="请选择" style="width: 90%">
                <el-option v-for="item in platlists" :key="item.id" :label="item.name" :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business" label="商家">
              <el-select v-loading="ptnListLoading" clearable v-model="form.business" placeholder="请选择" style="width: 90%">
                <el-option v-for="item in ptnlists" :key="item.id" :label="item.name" :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store" label="店铺">
              <el-select v-loading="shopListLoading" clearable v-model="form.store" placeholder="请选择" style="width: 90%">
                <el-option v-for="item in shoplists" :key="item.id" :label="item.name" :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine" :list="actionLineWithImport"></action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading" height="calc(100vh - 100px)" :data="tableData" border>
      <el-table-column prop="create_time" align="center" header-align="center" label="日期" width="100px"></el-table-column>
      <el-table-column prop="plan_name" align="center" header-align="center" label="所属计划" min-width="130px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="element_from" align="center" header-align="center" label="所属单元" min-width="180px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="element_name" align="center" header-align="center" label="元素名称" min-width="130px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="size" align="center" header-align="center" label="元素尺寸"></el-table-column>
      <el-table-column prop="text_l" align="center" header-align="center" label="长文本" min-width="200px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="text_s" align="center" header-align="center" label="短文本"></el-table-column>
      <el-table-column prop="url" align="center" header-align="center" label="详情url">
        <template slot-scope="scope">
          <!-- <el-button type></el-button> -->
          <a class="tag-a" target="_blank" :href="scope.row.url">详情</a>
        </template>
      </el-table-column>
      <el-table-column prop="zxliang" align="center" header-align="center" label="展现量"></el-table-column>
      <el-table-column prop="djliang" align="center" header-align="center" label="点击量"></el-table-column>
      <el-table-column prop="ctr" align="center" header-align="center" label="点击率(%)"></el-table-column>
      <el-table-column prop="hf" align="center" header-align="center" label="花费(元)"></el-table-column>
      <el-table-column prop="qczxcb" align="center" header-align="center" label="千次展现成本（元）"></el-table-column>
      <el-table-column prop="djdj" align="center" header-align="center" label="点击单价（元）"></el-table-column>
      <el-table-column align="center" header-aligin="center" prop="profession" label="行业" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" header-aligin="center" prop="business" label="商家" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" header-aligin="center" prop="store" label="店铺" min-width="110px" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryPrdlists.pagenum"
          :page-size="queryPrdlists.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile" ref="refImportDialog" />
    <export-dialog ref="refExportDialog" @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from "@/common/mixins/search-mixin";
import ActionLine from "@/common/mixins/action-line";
import { dealReturn } from "@/common/js/index.js";
import * as Desc from "./desc";
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    };
  },
  created() {
    // this.getTableData();
  },
  methods: {},
};
</script>

<style scoped>
.tag-a {
  text-decoration: none;
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/promote/starstore-element/index.vue